import { render } from "./indexbanner.vue?vue&type=template&id=7f5e2fd2"
import script from "./indexbanner.vue?vue&type=script&lang=js"
export * from "./indexbanner.vue?vue&type=script&lang=js"

import "./indexbanner.vue?vue&type=style&index=0&id=7f5e2fd2&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__